import '../tooltip';
import { defineCustomElement, getBooleanAttribute, getLiteralAttribute, getReactEventHandler, isAttrTrue, NectaryElement, subscribeContext, updateAttribute, updateBooleanAttribute, updateLiteralAttribute, Context, getAttribute, isAttrEqual } from '../utils';
import { DEFAULT_SIZE, sizeExValues } from '../utils/size';
const templateHTML = '<style>:host{display:inline-block;vertical-align:middle;outline:0}#button{display:block;position:relative;width:var(--sinch-local-size);height:var(--sinch-local-size);cursor:pointer;user-select:none;contain:size;--sinch-global-color-icon:var(--sinch-local-color-icon)}:host([disabled]) #button{cursor:initial}:host([data-size="l"]) #button{--sinch-local-size:var(--sinch-comp-button-size-container-l);--sinch-global-size-icon:var(--sinch-comp-button-size-icon-l);--sinch-local-shape-radius:var(--sinch-comp-button-shape-radius-size-l)}#button,:host([data-size="m"]) #button{--sinch-local-size:var(--sinch-comp-button-size-container-m);--sinch-global-size-icon:var(--sinch-comp-button-size-icon-m);--sinch-local-shape-radius:var(--sinch-comp-button-shape-radius-size-m)}:host([data-size="s"]) #button{--sinch-local-size:var(--sinch-comp-button-size-container-s);--sinch-global-size-icon:var(--sinch-comp-button-size-icon-s);--sinch-local-shape-radius:var(--sinch-comp-button-shape-radius-size-s)}:host([data-size=xs]) #button{--sinch-local-size:var(--sinch-comp-button-size-container-xs);--sinch-global-size-icon:var(--sinch-comp-button-size-icon-xs);--sinch-local-shape-radius:var(--sinch-comp-button-shape-radius-size-xs)}:host([type=primary]) #button{--sinch-local-color-background:var(--sinch-comp-button-color-primary-default-background-initial);--sinch-local-color-border:var(--sinch-comp-button-color-primary-default-border-initial);--sinch-local-color-icon:var(--sinch-comp-button-color-primary-default-icon-initial);--sinch-local-shadow:var(--sinch-comp-button-shadow-primary-initial);--sinch-local-color-outline:var(--sinch-comp-button-color-primary-default-outline-focus)}:host([type=secondary]) #button{--sinch-local-color-background:var(--sinch-comp-button-color-secondary-default-background-initial);--sinch-local-color-border:var(--sinch-comp-button-color-secondary-default-border-initial);--sinch-local-color-icon:var(--sinch-comp-button-color-secondary-default-icon-initial);--sinch-local-shadow:var(--sinch-comp-button-shadow-secondary-initial);--sinch-local-color-outline:var(--sinch-comp-button-color-secondary-default-outline-focus)}#button,:host([type=tertiary]) #button{--sinch-local-color-background:var(--sinch-comp-button-color-subtle-secondary-default-background-initial);--sinch-local-color-border:var(--sinch-comp-button-color-subtle-secondary-default-border-initial);--sinch-local-color-icon:var(--sinch-comp-button-color-subtle-secondary-default-icon-initial);--sinch-local-shadow:var(--sinch-comp-button-shadow-subtle-initial);--sinch-local-color-outline:var(--sinch-comp-button-color-subtle-secondary-default-outline-focus)}:host([type=primary][disabled]) #button{--sinch-local-color-background:var(--sinch-comp-button-color-primary-disabled-background-initial);--sinch-local-color-border:var(--sinch-comp-button-color-primary-disabled-border-initial);--sinch-local-color-icon:var(--sinch-comp-button-color-primary-disabled-icon-initial);--sinch-local-shadow:var(--sinch-comp-button-shadow-primary-disabled)}:host([type=secondary][disabled]) #button{--sinch-local-color-background:var(--sinch-comp-button-color-secondary-disabled-background-initial);--sinch-local-color-border:var(--sinch-comp-button-color-secondary-disabled-border-initial);--sinch-local-color-icon:var(--sinch-comp-button-color-secondary-disabled-icon-initial);--sinch-local-shadow:var(--sinch-comp-button-shadow-secondary-disabled)}:host([disabled]) #button,:host([type=tertiary][disabled]) #button{--sinch-local-color-background:var(--sinch-comp-button-color-subtle-secondary-disabled-background-initial);--sinch-local-color-border:var(--sinch-comp-button-color-subtle-secondary-disabled-border-initial);--sinch-local-color-icon:var(--sinch-comp-button-color-subtle-secondary-disabled-icon-initial);--sinch-local-shadow:var(--sinch-comp-button-shadow-subtle-disabled)}:host([type=primary]:focus) #button{--sinch-local-shadow:var(--sinch-comp-button-shadow-primary-focus)}:host([type=secondary]:focus) #button{--sinch-local-shadow:var(--sinch-comp-button-shadow-secondary-focus)}:host(:focus),:host([type=tertiary]:focus) #button{--sinch-local-shadow:var(--sinch-comp-button-shadow-subtle-focus)}:host([type=primary]:not([disabled]):hover) #button{--sinch-local-color-background:var(--sinch-comp-button-color-primary-default-background-hover);--sinch-local-shadow:var(--sinch-comp-button-shadow-primary-hover)}:host([type=secondary]:not([disabled]):hover) #button{--sinch-local-color-background:var(--sinch-comp-button-color-secondary-default-background-hover);--sinch-local-shadow:var(--sinch-comp-button-shadow-secondary-hover)}:host(:not([disabled]):hover) #button,:host([type=tertiary]:not([disabled]):active) #button{--sinch-local-color-background:var(--sinch-comp-button-color-subtle-secondary-default-background-hover);--sinch-local-shadow:var(--sinch-comp-button-shadow-subtle-hover)}:host([type=primary]:not([disabled]):active) #button{--sinch-local-color-background:var(--sinch-comp-button-color-primary-default-background-active);--sinch-local-shadow:var(--sinch-comp-button-shadow-primary-active)}:host([type=secondary]:not([disabled]):active) #button{--sinch-local-color-background:var(--sinch-comp-button-color-secondary-default-background-active);--sinch-local-shadow:var(--sinch-comp-button-shadow-secondary-active)}:host(:not([disabled]):active) #button,:host([type=tertiary]:not([disabled]):active) #button{--sinch-local-color-background:var(--sinch-comp-button-color-subtle-secondary-default-background-active);--sinch-local-shadow:var(--sinch-comp-button-shadow-subtle-active)}#button::before{content:"";position:absolute;inset:0;background-color:var(--sinch-local-color-background);border:1px solid var(--sinch-local-color-border);border-radius:var(--sinch-local-shape-radius);box-shadow:var(--sinch-local-shadow);pointer-events:none}:host(:focus-visible) #button::after{content:"";position:absolute;inset:-3px;border:2px solid var(--sinch-local-color-outline);border-radius:calc(var(--sinch-local-shape-radius) + 3px);pointer-events:none}#content{position:relative;display:flex;align-items:center;justify-content:center;width:100%;height:100%}</style><sinch-tooltip id="tooltip"><div id="button"><div id="content" inert><slot name="icon"></slot></div></div></sinch-tooltip>';
import { typeValues } from './utils';
const template = document.createElement('template');
template.innerHTML = templateHTML;
defineCustomElement('sinch-icon-button', class extends NectaryElement {
  #$button;
  #$tooltip;
  #controller = null;
  #sizeContext;
  constructor() {
    super();
    const shadowRoot = this.attachShadow();
    shadowRoot.appendChild(template.content.cloneNode(true));
    this.#$button = shadowRoot.querySelector('#button');
    this.#$tooltip = shadowRoot.querySelector('#tooltip');
    this.#sizeContext = new Context(this.#$button, 'size');
  }
  connectedCallback() {
    super.connectedCallback();
    this.#controller = new AbortController();
    const options = {
      signal: this.#controller.signal
    };
    this.role = 'button';
    this.tabIndex = 0;
    this.addEventListener('click', this.#onButtonClick, options);
    this.addEventListener('focus', this.#onButtonFocus, options);
    this.addEventListener('blur', this.#onButtonBlur, options);
    this.addEventListener('keydown', this.#onButtonKeydown, options);
    this.addEventListener('-click', this.#onClickReactHandler, options);
    this.addEventListener('-focus', this.#onFocusReactHandler, options);
    this.addEventListener('-blur', this.#onBlurReactHandler, options);
    this.#$tooltip.addEventListener('-show', this.#onTooltipShow, options);
    this.#$tooltip.addEventListener('-hide', this.#onTooltipHide, options);
    this.addEventListener('-tooltip-show', this.#onTooltipShowReactHandler, options);
    this.addEventListener('-tooltip-hide', this.#onTooltipHideReactHandler, options);
    subscribeContext(this, 'size', this.#onContextSize, this.#controller.signal);
    this.#sizeContext.listen(this.#controller.signal);
    this.#onSizeUpdate();
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    this.#controller.abort();
    this.#controller = null;
  }
  static get observedAttributes() {
    return ['size', 'disabled', 'aria-label', 'data-size'];
  }
  attributeChangedCallback(name, oldVal, newVal) {
    switch (name) {
      case 'disabled':
        {
          if (isAttrEqual(oldVal, newVal)) {
            return;
          }
          const isDisabled = isAttrTrue(newVal);
          this.ariaDisabled = isDisabled.toString();
          updateBooleanAttribute(this, 'disabled', isDisabled);
          break;
        }
      case 'aria-label':
        {
          updateAttribute(this.#$tooltip, 'text', newVal);
          break;
        }
      case 'size':
        {
          updateAttribute(this, 'data-size', newVal);
          break;
        }
      case 'data-size':
        {
          this.#onSizeUpdate();
          break;
        }
    }
  }
  set type(value) {
    updateLiteralAttribute(this, typeValues, 'type', value);
  }
  get type() {
    return getLiteralAttribute(this, typeValues, 'type', 'tertiary');
  }
  set disabled(isDisabled) {
    updateBooleanAttribute(this, 'disabled', isDisabled);
  }
  get disabled() {
    return getBooleanAttribute(this, 'disabled');
  }
  set size(size) {
    updateLiteralAttribute(this, sizeExValues, 'size', size);
  }
  get size() {
    return getLiteralAttribute(this, sizeExValues, 'size', DEFAULT_SIZE);
  }
  get tooltipRect() {
    return this.#$tooltip.tooltipRect;
  }
  get focusable() {
    return true;
  }
  #onSizeUpdate() {
    if (!this.isDomConnected) {
      return;
    }
    const size = getAttribute(this, 'data-size', DEFAULT_SIZE);
    this.#sizeContext.dispatch(size);
  }
  #onContextSize = e => {
    if (this.hasAttribute('size')) {
      return;
    }
    switch (e.detail) {
      case 'l':
        {
          this.setAttribute('data-size', 'm');
          break;
        }
      case 'm':
        {
          this.setAttribute('data-size', 's');
          break;
        }
      default:
        {
          this.setAttribute('data-size', 'xs');
        }
    }
  };
  #onButtonClick = () => {
    if (!this.disabled) {
      this.dispatchEvent(new CustomEvent('-click'));
    }
  };
  #onButtonFocus = () => {
    this.dispatchEvent(new CustomEvent('-focus'));
  };
  #onButtonBlur = () => {
    this.dispatchEvent(new CustomEvent('-blur'));
  };
  #onButtonKeydown = e => {
    switch (e.code) {
      case 'Space':
      case 'Enter':
        {
          e.preventDefault();
          this.click();
        }
    }
  };
  #onTooltipShow = () => {
    this.dispatchEvent(new CustomEvent('-tooltip-show'));
  };
  #onTooltipHide = () => {
    this.dispatchEvent(new CustomEvent('-tooltip-hide'));
  };
  #onFocusReactHandler = () => {
    getReactEventHandler(this, 'on-focus')?.();
  };
  #onBlurReactHandler = () => {
    getReactEventHandler(this, 'on-blur')?.();
  };
  #onClickReactHandler = e => {
    getReactEventHandler(this, 'on-click')?.(e);
  };
  #onTooltipShowReactHandler = () => {
    getReactEventHandler(this, 'on-tooltip-show')?.();
  };
  #onTooltipHideReactHandler = () => {
    getReactEventHandler(this, 'on-tooltip-hide')?.();
  };
});